import _ from "lodash";

export default (products, sortBy) => {
  if (sortBy === "interestRate") {
    return _.sortBy(products, ({ node }) => {
      return -node.interestRate;
    });
  } else if (sortBy === "banks") {
    return _.sortBy(products, ({ node }) => {
      return node.bank.label;
    });
  }

  return products;
};
